"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_accordion_1 = __importDefault(require("@uswds/uswds/js/usa-accordion"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function AccordionGroup({ border, children, className, multiselect, ...props }) {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const containerEl = containerRef.current;
        if (!containerEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_accordion_1.default.on(containerEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_accordion_1.default.off(containerEl);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('bah-uswds-accordion', className), ref: containerRef, children: (0, jsx_runtime_1.jsx)("div", { className: (0, uswds_react_utils_1.createClassString)('usa-accordion', border && 'usa-accordion--bordered', multiselect && 'usa-accordion--multiselectable'), "data-allow-multiple": multiselect ? true : undefined, ...props, children: children }) }));
}
exports.default = AccordionGroup;
